module.exports = __webpack_public_path__ + "img/4-bg.ebb1ddf2.png";